// Main navigation, ordered by what a buyer needs first: what we sell, which grade
// to pick, how ordering works, then background reading. The logo links home.
// Labels for each language live in i18n/<lang>/common.js under `nav`.
export const NAV_PATHS = ['/products', '/uses', '/how-we-work', '/true-cinnamon', '/contact'];

// Every page, used for routing and for generating a static copy of each page at build time
export const PAGE_PATHS = ['/', ...NAV_PATHS];
